import React from 'react';
import {useDispatch} from "react-redux";
import {triggerAboutTable, triggerHelpTable} from "../../../store/layouts/actions";
import CloseIconComponent from "../../reusable/CloseIconComponent";
import logo from '../../../assets/images/logo-long-Q.png';
import './style.scss';


const AboutComponent = () => {
    const dispatch = useDispatch();

    const closeHandler = () => {
        dispatch(triggerAboutTable(false))
    };

    return (
        <div className='about'>
            <div className='about__title'>
                <CloseIconComponent handler={closeHandler}/>
                About
            </div>
            <div className='about__content'>
                <div className='about-content__item'>
                    Qognify Web Client {window.VARIABLES.version}
                </div>
                <div className='about-content__item'
                     onClick={closeHandler}
                >
                    <a href="https://www.qognify.com"
                       target='_blank'
                    > www.qognify.com </a>
                </div>
                <div className='about-content__item'>
                    Copyright © 2021 Qognify, Inc.
                </div>
                <div className='about-content__item'>
                    <img src={logo} alt="Qognify"/>
                </div>
            </div>
        </div>
    );
};

export default AboutComponent;